export const MethodType = {
  GET: "GET",
  POST: "POST",
  PATCH: "PATCH",
  PUT: "PUT",
  DELETE: "DELETE",
  FORMDATA: "FORMDATA",
}

export const StatusCodes = {
  Error: "500",
  InvalidData: "422",
  Success: "200",
  Unauthorized: "401",
  InvalidMediaType: "415",
  Forbidden: "403",
  NotFound: "404",
  Duplicate: "409",
  NotAllowed: "405",
}

export const dateFormat = "dd/MM/yyyy"

export const PasswordRegex = ""

export const masterListPageTableTheme = {
  rows: {
    height: "35px",
    cursor: "pointer",
  },
}
